var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTitle = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 200,
  height: 32,
  viewBox: "0 0 200 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M196 0C198.209 0 200 1.79086 200 4V28C200 30.2091 198.209 32 196 32H4C1.79086 32 0 30.2091 0 28V4C0 1.79086 1.79086 0 4 0H196Z",
  fill: "black",
  fillOpacity: 0.1
})));
export default SvgTitle;